// extracted by mini-css-extract-plugin
export default {"wrapper":"HouseModelSidebar_wrapper__AYagD","btn":"HouseModelSidebar_btn__D+Vfi","current":"HouseModelSidebar_current__duEam","imgWrap":"HouseModelSidebar_imgWrap__u2xCC"};